import { render, staticRenderFns } from "./IncomingProjects.vue?vue&type=template&id=918f0130&"
import script from "./IncomingProjects.vue?vue&type=script&lang=js&"
export * from "./IncomingProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports